import checkIcon from '../icons/check.svg';
import errorIcon from '../icons/error.svg';
import infoIcon from '../icons/info.svg';
import warningIcon from '../icons/warning.svg';

export type ToastBackground = 'Primary' | 'Secondary' | 'Success' | 'Danger' | 'Warning' | 'Info' | 'Light' | 'Dark';
export type ToastIcon = typeof checkIcon | typeof errorIcon | typeof warningIcon | typeof infoIcon;

export interface CustomToast {
  id: number;
  title: string;
  description: string;
  backgroundColor: ToastBackground;
  icon: string;
}

export class ToastSample {
  static toastSuccess(title: string, description: string) {
    return {
      id: Math.floor(Math.random() * 101 + 1),
      title: title,
      description: description,
      backgroundColor: 'Success',
      icon: checkIcon,
    } as CustomToast;
  }

  static toastError(title: string, description: string) {
    return {
      id: Math.floor(Math.random() * 101 + 1),
      title: title,
      description: description,
      backgroundColor: 'Danger',
      icon: errorIcon,
    } as CustomToast;
  }

  static toastInfo(title: string, description: string) {
    return {
      id: Math.floor(Math.random() * 101 + 1),
      title: title,
      description: description,
      backgroundColor: 'Info',
      icon: infoIcon,
    } as CustomToast;
  }

  static toastWarning(title: string, description: string) {
    return {
      id: Math.floor(Math.random() * 101 + 1),
      title: title,
      description: description,
      backgroundColor: 'Warning',
      icon: warningIcon,
    } as CustomToast;
  }
}
